module.exports = __webpack_public_path__ + "static/media/scythe.12fd133d.svg";